<template>
  <div id="app">
    <div>
      <router-view />
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return{

    }
  },
  created() {
      let self = this;

      //i18n多语言组件的引入与判断
      if (self.$cookies.get('lang') == null) {
        self.$i18n.locale = 'zh'
        self.$cookies.set('lang','zh')
      } else {
        self.$i18n.locale = self.$cookies.get('lang');
         //页面加载时，将语言设置为用户选择的语言
      }


    }
}
</script>
<style>
#app {
  background-color: black;
}
.tests {
  /* background-color: blue; */
}
* {
  padding: 0;
  margin: 0;
}
img {
  max-width: 100%;
}
a{
  text-decoration: none;
}
@media (min-width: 768px) {
  .main {
    width: 1200px;
    margin: 0 auto;
  }
  .main-1440 {
    width: 1440px;
    margin: 0 auto;
  }
  .Foot-1440 {
    width: 1440px;
    margin: 0 auto;
  }
}
@media (max-width: 768px) {
  body {
    overflow-x: hidden;
  }
  .main {
    margin-left:  5px;
    margin-right:  5px;
    padding-left:  5px;
    padding-right:  5px;
  }
}
.opacity-0{
  opacity: 0;
}
</style>
